import PropTypes from "prop-types";
import cn from "classnames";
import styles from "components/shared/stays/Divider.module.scss";

export default function Divider({ slim = false }) {
  return (
    <div
      className={cn(styles.component, slim ? styles.slim : styles.default)}
    />
  );
}

Divider.propTypes = {
  slim: PropTypes.bool,
};
